import PaintSuppliersWorkspace from '../../placeholders/PaintSuppliersWorkspace';

export default PaintSuppliersWorkspace;
